(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hatchill-archive-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'hatchill_archive_click_v1';
  const lifetime = 30 * 60 * 1000;
  const visible = new Set();
  const reported = new WeakSet();
  const initialized = new WeakSet();
  let observer;

  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  }

  function forget() {
    try { window.sessionStorage.removeItem(storageKey); } catch {}
  }

  function track(name, properties) {
    if (!allowed() || window.Shopify?.designMode) return;
    const payload = { location: 'archive_finds', creative_version: 'archive-finds-20260922', ...properties };
    try { window.HatchillEvents?.track(name, payload); } catch {}
    try { window.Shopify?.analytics?.publish('hatchill:' + name, payload)?.catch(() => {}); } catch {}
  }

  function productData(card) {
    return { product_id: card.dataset.archiveProduct, variant_id: card.dataset.archiveVariant, position: Number(card.dataset.archivePosition) };
  }

  function reportVisible() {
    if (!allowed()) return;
    visible.forEach(element => {
      if (!element.isConnected) { visible.delete(element); return; }
      if (reported.has(element)) return;
      const root = element.closest('[data-hatchill-archive]');
      if (!root) return;
      const isCard = element.hasAttribute('data-archive-product');
      track(isCard ? 'archive_finds_product_viewed' : 'archive_finds_viewed', {
        locale: root.dataset.locale,
        currency: root.dataset.currency,
        ...(isCard ? productData(element) : { product_ids: [...root.querySelectorAll('[data-archive-product]')].map(card => card.dataset.archiveProduct) })
      });
      reported.add(element);
      observer?.unobserve(element);
      visible.delete(element);
    });
  }

  function init() {
    if ('IntersectionObserver' in window && !observer) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= .3) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        reportVisible();
      }, { threshold: [.3] });
    }
    document.querySelectorAll('[data-hatchill-archive]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      observer?.observe(root);
      root.querySelectorAll('[data-archive-product]').forEach(card => observer?.observe(card));
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-archive-link]');
        if (!link || !root.contains(link) || !allowed() || window.Shopify?.designMode) return;
        const card = link.closest('[data-archive-product]');
        const properties = { destination_type: link.dataset.archiveLink, locale: root.dataset.locale, currency: root.dataset.currency, ...(card ? productData(card) : {}) };
        track('archive_finds_clicked', properties);
        if (card) {
          try { window.sessionStorage.setItem(storageKey, JSON.stringify({ ...properties, clicked_at: Date.now() })); } catch {}
        }
      });
    });
  }

  function onCartUpdate(event) {
    if (!allowed()) { forget(); return; }
    if (event?.source !== 'product-form-component' || !event.cartData || event.cartData.status) return;
    let attribution;
    try { attribution = JSON.parse(window.sessionStorage.getItem(storageKey)); } catch { return; }
    if (!attribution) return;
    const age = Date.now() - Number(attribution.clicked_at);
    if (!Number.isFinite(age) || age < 0 || age > lifetime) { forget(); return; }
    const items = Array.isArray(event.cartData.items) ? event.cartData.items : [event.cartData];
    const added = items.find(item => String(item.product_id) === attribution.product_id);
    if (!added) return;
    track('archive_finds_added_to_cart', {
      product_id: attribution.product_id,
      variant_id: String(added.variant_id || added.id),
      position: attribution.position,
      locale: attribution.locale,
      currency: attribution.currency
    });
    forget();
  }

  function start() {
    init();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    if (window.Shopify?.customerPrivacy) {
      if (!allowed()) forget();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (error) return;
        if (!allowed()) forget();
        reportVisible();
      });
    }
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) forget();
    reportVisible();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hatchill-cart-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hatchill-cart-addons')) {
    customElements.define('hatchill-cart-addons', class extends HTMLElement {
      static recommendationCache = new Map();
      static async recommendationPool(endpoint, productId, intent, namespace) {
        let url;
        try { url = new URL(endpoint, location.origin); } catch { return []; }
        if (url.origin !== location.origin || !/\/recommendations\/products\.json$/.test(url.pathname)) return [];
        url.searchParams.set('product_id', productId);
        url.searchParams.set('intent', intent);
        url.searchParams.set('limit', '8');
        const key = `${namespace}|${url.href}`;
        const cache = this.recommendationCache;
        const cached = cache.get(key);
        if (cached && cached.expires > Date.now()) return cached.promise;
        if (cache.size >= 48) cache.delete(cache.keys().next().value);
        const entry = { expires: Date.now() + 300000 };
        entry.promise = fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) })
          .then(async response => { if (!response.ok) { entry.expires = Date.now() + 30000; return []; } return (await response.json()).products; })
          .then(products => Array.isArray(products) ? products : [])
          .catch(() => { entry.expires = Date.now() + 30000; return []; });
        cache.set(key, entry);
        return entry.promise;
      }
      static chooseProducts(pools, basketIds) {
        const seen = new Set(basketIds.map(String)), result = [];
        const queues = pools.map(pool => Array.isArray(pool) ? [...pool] : []);
        while (result.length < 2 && queues.some(queue => queue.length)) {
          for (const queue of queues) {
            while (queue.length) {
              const product = queue.shift();
              if (!product || !/^\d+$/.test(String(product.id)) || seen.has(String(product.id)) || product.available !== true ||
                  product.gift_card || product.requires_selling_plan || typeof product.title !== 'string' || !product.title.trim() || !product.featured_image || !Array.isArray(product.variants)) continue;
              const eligibleVariants = product.variants.filter(variant => /^\d+$/.test(String(variant.id)) && variant.available === true &&
                Number.isSafeInteger(Number(variant.price)) && Number(variant.price) > 0 && (variant.quantity_rule?.min ?? 1) <= 1 && (variant.quantity_rule?.increment ?? 1) <= 1 &&
                (variant.quantity_rule?.max == null || variant.quantity_rule.max >= 1));
              if (!eligibleVariants.length) continue;
              seen.add(String(product.id));
              result.push({ ...product, eligibleVariants, price: Math.min(...eligibleVariants.map(variant => Number(variant.price))),
                directAdd: product.variants.length === 1 && eligibleVariants[0].title === 'Default Title' });
              break;
            }
            if (result.length === 2) break;
          }
        }
        return result;
      }
      async refreshRecommendations() {
        if (!this.dataset.recommendationsUrl) return;
        const generation = this.recommendationGeneration = (this.recommendationGeneration || 0) + 1;
        let seeds, basketIds;
        try {
          basketIds = JSON.parse(this.dataset.cartProducts);
          seeds = [...new Set(JSON.parse(this.dataset.recommendationSeeds).map(String))].filter(id => /^\d+$/.test(id)).slice(0, 3);
          if (!Array.isArray(basketIds)) return;
        } catch { return; }
        const namespace = `${this.dataset.locale}|${this.dataset.currency}`;
        const pools = await Promise.all(seeds.map(async id => {
          const complementary = await this.constructor.recommendationPool(this.dataset.recommendationsUrl, id, 'complementary', namespace);
          if (!this.isConnected || generation !== this.recommendationGeneration) return {products:[],intent:'related'};
          if (this.constructor.chooseProducts([complementary], basketIds).length) return {products:complementary,intent:'complementary'};
          return {products:await this.constructor.recommendationPool(this.dataset.recommendationsUrl, id, 'related', namespace),intent:'related'};
        }));
        if (!this.isConnected || generation !== this.recommendationGeneration) return;
        const complements = pools.filter(pool => pool.intent === 'complementary');
        const intent = complements.length ? 'complementary' : 'related';
        const products = this.constructor.chooseProducts((complements.length ? complements : pools).map(pool => pool.products), basketIds);
        if (products.length) this.renderRecommendations(products, intent);
      }
      renderRecommendations(products, intent = 'related') {
        const drawer = this.closest('cart-drawer');
        if (drawer?.dataset.addonBusy || drawer?.querySelector('.cart-items-disabled')) return;
        const list = this.querySelector('ul');
        if (!list) return;
        if (list.contains(document.activeElement) || [...list.querySelectorAll('[data-addon-variant]')].some(select => select.value) ||
            list.querySelector('[data-addon-blocked="true"]')) return;
        const rows = [];
        const prefix = new URL(this.dataset.recommendationsUrl, location.origin).pathname.split('/recommendations/')[0];
        const formatPrice = cents => new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' }).format(cents / 100);
        for (const product of products) {
          let url, image;
          try {
            url = new URL(product.url, location.origin);
            const imageSource = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.url || product.featured_image.src;
            if (typeof imageSource !== 'string' || !imageSource.trim()) continue;
            image = new URL(imageSource, location.origin);
            if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(url.pathname) || image.protocol !== 'https:' ||
                (image.origin !== location.origin && image.hostname !== 'cdn.shopify.com')) continue;
            if (prefix && url.pathname.startsWith('/products/')) url.pathname = prefix + url.pathname;
          } catch { continue; }
          const make = (tag, className, text) => { const node = document.createElement(tag); node.className = className; if (text) node.textContent = text; return node; };
          const row = make('li', 'hatchill-cart-addon'); row.dataset.addonProduct = String(product.id);
          const photo = make('a', 'hatchill-cart-addon__image'); photo.href = url.href; photo.tabIndex = -1; photo.setAttribute('aria-hidden', 'true');
          const img = document.createElement('img'); img.src = image.href; img.alt = ''; img.width = 64; img.height = 64; img.loading = 'lazy'; photo.append(img);
          const details = make('div', 'hatchill-cart-addon__details');
          const title = make('a', 'hatchill-cart-addon__title', product.title); title.href = url.href;
          const priceText = formatPrice(product.price);
          const price = make('span', 'hatchill-cart-addon__price', product.price_varies ? this.dataset.fromPrice.replace('__PRICE__', priceText) : priceText); price.dataset.addonPrice = '';
          details.append(title, price);
          const action = make(product.directAdd ? 'button' : 'a', 'hatchill-cart-addon__add', product.directAdd ? this.dataset.addLabel : this.dataset.chooseLabel);
          if (product.directAdd) {
            action.type = 'button'; action.dataset.addonAdd = ''; action.dataset.variantId = String(product.eligibleVariants[0].id);
            action.setAttribute('aria-label', this.dataset.addProductLabel.replace('__PRODUCT__', product.title));
          } else action.href = url.href;
          row.append(photo, details, action); rows.push(row);
        }
        if (!rows.length) return;
        list.replaceChildren(...rows);
        this.querySelector('h2').textContent = intent === 'complementary' ? this.dataset.complementaryHeading : this.dataset.relatedHeading;
        const note = this.querySelector('[data-addon-note]'); note.textContent = intent === 'complementary' ? this.dataset.complementaryNote : this.dataset.relatedNote; note.hidden = false;
        this.hidden = false;
      }
      connectedCallback() {
        this.onClick = event => {
          const button = event.target.closest('[data-addon-add]');
          if (button && this.contains(button)) this.add(button);
        };
        this.onChange = event => {
          if (!event.target.matches('[data-addon-variant]')) return;
          const row = event.target.closest('[data-addon-product]');
          const button = row.querySelector('[data-addon-add]');
          const option = event.target.selectedOptions[0];
          button.dataset.variantId = option?.value || '';
          button.disabled = !option?.value || row.dataset.addonBlocked === 'true' || !!this.closest('cart-drawer')?.dataset.addonBusy;
          row.querySelector('[data-addon-price]').textContent = option?.dataset.price || row.dataset.fromPrice;
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.onDrawerOpen = event => {
          if (event.detail?.drawer && event.detail.drawer !== this.closest('cart-drawer')) return;
          this.refreshRecommendations().catch(() => {});
        };
        document.addEventListener?.('cart-drawer:open', this.onDrawerOpen);
        if (this.closest('cart-drawer')?.classList?.contains('open')) this.onDrawerOpen({});
      }
      disconnectedCallback() {
        this.recommendationGeneration = (this.recommendationGeneration || 0) + 1;
        document.removeEventListener?.('cart-drawer:open', this.onDrawerOpen);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
      }
      async add(button) {
        const drawer = this.closest('cart-drawer');
        if (!drawer || drawer.dataset.addonBusy || button.disabled || !/^\d+$/.test(button.dataset.variantId || '')) return;
        const status = this.querySelector('[data-addon-status]');
        if (drawer.querySelector('.cart-items-disabled')) {
          status.textContent = this.dataset.updating;
          return;
        }
        drawer.dataset.addonBusy = 'true';
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('[data-addon-add], [data-addon-variant]').forEach(control => { control.disabled = true; });
        const locked = Array.from(drawer.querySelectorAll('.drawer__cart-items-wrapper, .drawer__footer')).filter(element => !element.inert);
        locked.forEach(element => { element.inert = true; });
        status.textContent = this.dataset.adding;
        const sectionIds = drawer.getSectionsToRender().map(section => section.id);
        const row = button.closest('[data-addon-product]');
        const variantId = button.dataset.variantId;
        let confirmed = false;
        let rejected = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds, sections_url: location.pathname }),
            signal: AbortSignal.timeout(20000)
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            rejected = response.status >= 400 && response.status < 500;
            throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          }
          confirmed = true;
          row.remove();
          let sections = data.sections;
          if (!sectionIds.every(id => typeof sections?.[id] === 'string' && sections[id].trim())) {
            const url = new URL(location.href);
            url.searchParams.set('sections', sectionIds.join(','));
            const refresh = await fetch(url, { signal: AbortSignal.timeout(15000) });
            if (!refresh.ok) throw new Error(this.dataset.added);
            sections = await refresh.json();
          }
          if (!sectionIds.every(id => typeof sections?.[id] === 'string' && sections[id].trim())) throw new Error(this.dataset.added);
          await drawer.renderContents({ ...data, sections });
          const liveRegion = drawer.querySelector('#CartDrawer-LiveRegionText');
          if (liveRegion) liveRegion.textContent = this.dataset.added;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hatchill-cart-addons', productVariantId: variantId, cartData: data });
          }
          document.dispatchEvent(new CustomEvent('hatchill:cart-addon-added', { detail: { productId: row.dataset.addonProduct, variantId } }));
        } catch (error) {
          status.textContent = confirmed ? this.dataset.added : rejected ? error.message : this.dataset.uncertain;
          this.querySelector('[data-addon-recovery]').hidden = false;
          row.dataset.addonBlocked = 'true';
        } finally {
          delete drawer.dataset.addonBusy;
          locked.forEach(element => { element.inert = false; });
          this.removeAttribute('aria-busy');
          if (this.isConnected) {
            this.querySelectorAll('[data-addon-variant]').forEach(select => { select.disabled = select.closest('[data-addon-product]').dataset.addonBlocked === 'true'; });
            this.querySelectorAll('[data-addon-add]').forEach(control => {
              control.disabled = !control.dataset.variantId || control.closest('[data-addon-product]').dataset.addonBlocked === 'true';
            });
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hatchill-fit-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hatchill-fit-link')) {
    customElements.define('hatchill-fit-link', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        const section = this.closest('product-info');
        const disclosure = section?.querySelector('.hatchill-product-confidence__disclosure--fit');
        if (!button) return;
        button.hidden = !disclosure;
        if (!disclosure) return;
        button.onclick = () => {
          const current = this.closest('product-info')?.querySelector('.hatchill-product-confidence__disclosure--fit');
          if (!current) return;
          current.open = true;
          current.querySelector('summary')?.focus({ preventScroll: true });
          current.scrollIntoView({ block: 'center', behavior: 'auto' });
        };
      }
      disconnectedCallback() {
        const button = this.querySelector('button');
        if (button) {
          button.onclick = null;
          button.hidden = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
